import { PlusIcon } from "@heroicons/react/24/outline";
import React from "react";

const primaryPlusClasses =
    "twoverride inline-flex items-center gap-1 rounded-full bg-gradient-to-b from-brand-500 to-brand-600 " +
    "px-3.5 py-1.5 text-sm font-semibold text-white shadow-sm transition " +
    "hover:from-brand-400 hover:to-brand-500 hover:shadow " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 " +
    "disabled:from-gray-400 disabled:to-gray-400 disabled:text-gray-200";

const PrimaryPlusButton = React.forwardRef<
    HTMLButtonElement,
    React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
    const { className, children, type, ...rest } = props;
    return (
        <button
            ref={ref}
            type={type ?? "button"}
            className={`${className ?? ""} ${primaryPlusClasses}`}
            {...rest}>
            <PlusIcon aria-hidden="true" className="-ml-0.5 h-4 w-4" strokeWidth={2.5} />
            {children}
        </button>
    );
});

PrimaryPlusButton.displayName = "PrimaryPlusButton";
export { PrimaryPlusButton };
